var map = {
	"./apple-pay.svg": "1a89",
	"./banner-1.jpg": "3398",
	"./cart.svg": "d176",
	"./checkout-done.png": "47cf",
	"./collection-1.png": "d07b",
	"./collection-2.png": "8118",
	"./collection-3.png": "cdb9",
	"./family-mart.svg": "2e2c",
	"./home-delivery.svg": "15d3",
	"./icon-facebook.svg": "b05a",
	"./icon-instagram.svg": "1b5e",
	"./icon-pinterest.svg": "5b29",
	"./icon-youtube.svg": "a05c",
	"./jcb.svg": "193a",
	"./jkopay.svg": "085c",
	"./line-pay.svg": "7b46",
	"./logo.png": "4ffd",
	"./master-card.svg": "8584",
	"./news-1.jpg": "c724",
	"./news-2.jpg": "de6d",
	"./product-1-details.jpg": "6c9d",
	"./product-1-thumb-1.jpg": "106a",
	"./product-1-thumb-10.jpg": "4422",
	"./product-1-thumb-2.jpg": "4318",
	"./product-1-thumb-3.jpg": "b16d",
	"./product-1-thumb-4.jpg": "5113",
	"./product-1-thumb-5.jpg": "e35a",
	"./product-1-thumb-6.jpg": "084a",
	"./product-1-thumb-7.jpg": "3b2a",
	"./product-1-thumb-8.jpg": "8c15",
	"./product-1-thumb-9.jpg": "61a6",
	"./product-1.jpg": "f6fe",
	"./product-2.jpg": "8506",
	"./product-3.jpg": "7827",
	"./product-4.jpg": "33fc",
	"./product-5.jpg": "b4c2",
	"./product-6.jpg": "1964",
	"./product-7.jpg": "efcc",
	"./product-8.jpg": "d05a",
	"./product-9.jpg": "73c0",
	"./search.svg": "6f6b",
	"./seven-eleven.svg": "8f8e",
	"./unionpay.svg": "9f54",
	"./user.svg": "f41a",
	"./visa.svg": "6180"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";